module.exports = __webpack_public_path__ + "static/img/200076.ed63c8ba.png";